import React from 'react';
import { ComponentWithAs, Flex, FlexProps, forwardRef } from '@chakra-ui/react';
import HomeButton from '../molecule/HomeButton';

const HomeButtonSection: ComponentWithAs<'div', FlexProps> = forwardRef<FlexProps, 'div'>((props, ref) => {
  return (
    <Flex position='fixed' left='0' top='0' {...props} ref={ref}>
      <HomeButton />
    </Flex>
  );
});

export default HomeButtonSection;
